import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExportOutlinedSvg from "@ant-design/icons-svg/es/asn/ExportOutlined";
import AntdIcon from "../components/AntdIcon";
var ExportOutlined = function ExportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExportOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExportOutlined.displayName = 'ExportOutlined';
}
export default /*#__PURE__*/React.forwardRef(ExportOutlined);